import {sendAmplitudeEvent} from '#/analytics/amplitude-events';
import connectImg from '#/assets/coonect.png';
import trackImg from '#/assets/track.png';
import welcome from '#/assets/weclome1.png';
import {Modal} from '#/atoms/modal';
import {ReactComponent as BorrowIcon} from '#/components/icons/ico-borrow.svg';
import {ReactComponent as GraphIcon} from '#/components/icons/ico-graph.svg';
import {ReactComponent as PinIcon} from '#/components/icons/ico-pin.svg';
import {LoginGroup, MobileLoginGroup} from '#/components/login/login-group';
import {NumberPad, Step} from '#/components/welcome-modal/Step';
import {useModalContext} from '#/contexts/modal-provider';
import {Questions} from '#/pages/landing';
import {FunctionComponent, ReactElement, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useWindowSize} from 'react-use';

export type Content = {
  Icon: ReactElement<any, any>;
  header: string;
  sub?: string;
};

export const WelcomeModal: FunctionComponent = () => {
  const {t} = useTranslation('translation');
  const [stepIndex, setStepIndex] = useState(0);
  const {width} = useWindowSize();
  // Contexts
  const {close} = useModalContext();

  const modalContents = [
    {
      title: t('welcome.step1Title'),
      src: welcome,
      description: t('welcome.step1Description'),
      contents: [
        {
          Icon: <PinIcon />,
          header: t('welcome.explore'),
          sub: t('welcome.exploreSub'),
        },
        {
          Icon: <BorrowIcon />,
          header: t('welcome.transact'),
          sub: t('welcome.transactSub'),
        },
        {
          Icon: <GraphIcon />,
          header: t('welcome.monitor'),
          sub: t('welcome.monitorSub'),
        },
      ],
    },
    {
      title: t('welcome.step2Title'),
      description: t('welcome.step2Description'),
      src: trackImg,
      contents: [
        {
          Icon: <NumberPad num={1} />,
          header: t('welcome.findNeighbor'),
        },
        {
          Icon: <NumberPad num={2} />,
          header: t('welcome.invest'),
        },
        {
          Icon: <NumberPad num={3} />,
          header: t('welcome.track'),
        },
      ],
    },
  ];

  const handleContinue = () => {
    setStepIndex(prev => prev + 1);
    if (stepIndex === 0) {
      sendAmplitudeEvent.firstWelcomeModalContinueClicked({event_type: 'first_welcome_modal_continue'});
    } else {
      sendAmplitudeEvent.secondWelcomeModalContinueClicked({event_type: 'second_welcome_modal_continue'});
    }
  };

  const renderLoginContent = () => {
    if (width < 640) {
      return <MobileLoginGroup />;
    }
    return (
      <div className='flex justify-center py-6 md:py-10'>
        <div className='w-full md:w-3/5 px-4 md:px-0'>
          <h6 className='font-bold text-xl md:text-2xl mb-4 md:mb-6'>{t('pages.landing.explanation.connectWallet')}</h6>
          <LoginGroup />
          <div className='pt-4 pb-3'>
            <Questions hideIcon />
          </div>
        </div>
      </div>
    );
  };

  return (
    <Modal title='' onClose={close} hideOnClickAway={false} className='md:rounded-3xl border-none top-[-36px]'>
      <div className='w-full max-w-[800px] mx-auto md:rounded-2xl md:h-[800px] md:overflow-y-auto'>
        {stepIndex < 2 ? (
          <Step onClick={handleContinue} {...modalContents[stepIndex]} />
        ) : (
          <>
            <img src={connectImg} alt='connect_image' className='w-full h-auto' />
            {renderLoginContent()}
          </>
        )}
        {stepIndex < 2 && (
          <div className='flex justify-center gap-2 md:gap-3 mb-4 md:mb-6'>
            {Array.from({length: 3}).map((_, index) => (
              <div
                key={index}
                className={`w-2 h-2 rounded-full ${stepIndex === index ? 'bg-black' : 'bg-gray-300'}`}
              ></div>
            ))}
          </div>
        )}
      </div>
    </Modal>
  );
};
